import { memo, useState } from "react"
import { makeStyles } from "tss-react/mui"
import { Box, IconButton } from "@mui/material"
import { faHeart } from "@fortawesome/pro-solid-svg-icons"
import { faHeart as faHeartBorder } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { OfferDetailsType } from "../../../../../../modules/merchant/admin/products/productsTypes"
import ProductImg from "./ProductImg"
import { OfferTag } from "./OfferTag"

export const CARD_BORDER_RADIUS = "1rem"

const useStyles = makeStyles()((theme) => ({
    iconButton: {
        position: "absolute",
        top: "0.75rem",
        right: "0.75rem",
        padding: "0.375rem",
        background: "rgba(255, 255, 255, 0.5)",
        color: theme.palette.tailwind.blue[600],
        transition: "all 0.3s ease-out",
        "&:hover": {
            background: "white",
            color: theme.palette.tailwind.blue[800],
        },
    },
}))

type ProductTopInfoProps = {
    productId: number
    imageUrl?: string
    offerDetails?: OfferDetailsType
    isFavoriteProduct: boolean
    handleFavoriteProduct: (id: number, makeFavorite: boolean) => Promise<boolean>
}

export const ProductTopInfo = memo(
    ({ productId, imageUrl, offerDetails, handleFavoriteProduct, isFavoriteProduct }: ProductTopInfoProps) => {
        const { classes } = useStyles()

        const [isFavorite, setIsFavorite] = useState(isFavoriteProduct)

        const handleFavoriteClick = async () => {
            const next = !isFavorite
            const ok = await handleFavoriteProduct(productId, next)
            if (ok) setIsFavorite(next)
        }

        return (
            <Box position="relative">
                <ProductImg imageUrl={imageUrl} />

                {offerDetails && <OfferTag top="0.75rem" left="0.75rem" offerDetails={offerDetails} size="sm" />}
                <IconButton onClick={handleFavoriteClick} className={classes.iconButton} size="small">
                    {isFavorite ? <FontAwesomeIcon icon={faHeart} /> : <FontAwesomeIcon icon={faHeartBorder} />}
                </IconButton>
            </Box>
        )
    },
)
